import { Button, Modal, Trans } from '@/components'

interface InsufficientStorageModalProps {
  open: boolean
  requiredStorageGB: number
  baseStorageGB: number
  maxExtraStorageGB: number
  onClose: () => void
}

export function InsufficientStorageModal({
  open,
  requiredStorageGB,
  baseStorageGB,
  maxExtraStorageGB,
  onClose,
}: InsufficientStorageModalProps) {
  const maxStorageGB = baseStorageGB + maxExtraStorageGB

  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header>
        <Trans i18nKey="create.insufficientStorageTitle">Insufficient Storage Capacity</Trans>
      </Modal.Header>
      <Modal.Body>
        <div className="t-sm text-secondary">
          <p>
            <Trans
              i18nKey="create.insufficientStorageRequired"
              values={{ size: requiredStorageGB }}
              components={{ highlight: <span className="text-btn-secondary" /> }}
            >
              The selected image or snapshot requires at least{' '}
              <span className="text-btn-secondary">{'{{size}}'} GB</span> of storage to be
              provisioned.
            </Trans>
          </p>
          <p>
            <Trans
              i18nKey="create.insufficientStorageBase"
              values={{ size: baseStorageGB }}
              components={{ highlight: <span className="text-btn-secondary" /> }}
            >
              The selected machine includes{' '}
              <span className="text-btn-secondary">{'{{size}}'} GB</span> of base storage.
            </Trans>
          </p>
          <p>
            <Trans
              i18nKey="create.insufficientStorageExtraLimit"
              values={{ extraSize: maxExtraStorageGB, totalSize: maxStorageGB }}
              components={{ highlight: <span className="text-btn-secondary" /> }}
            >
              This machine can add at most{' '}
              <span className="text-btn-secondary">{'{{extraSize}}'} GB</span> of extra storage, so
              the maximum available storage is{' '}
              <span className="text-btn-secondary">{'{{totalSize}}'} GB</span>.
            </Trans>
          </p>
          <p>
            <Trans i18nKey="create.insufficientStorageSuggestion">
              Please choose a machine with more storage or select an image or snapshot with lower
              storage requirements.
            </Trans>
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="outline" className="min-w-[88px]" onClick={onClose}>
          <Trans i18nKey="common.confirmModalCancel">Cancel</Trans>
        </Button>
        <Button type="secondary" className="min-w-[88px]" onClick={onClose}>
          <Trans i18nKey="create.insufficientStorageOk">OK</Trans>
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
